<!-- EM_MO_SB_009  일반충전 -->
<template>
    <div class="stopusing-detail-wrap" @click="modalClose()">
        <div class="stopusing-text-box">
            <strong>환불<span>을</span></strong>
            <span>신청하시겠습니까?</span>
        </div>
        <div class="stopusing-detail-top" v-if="prepaidCardInfo">
<!--            <img :src=prepaidCardInfo.imageUrl>-->
            <span class="card-image-border-none" :style="{ backgroundImage:'url('+prepaidCardInfo.imageUrl+')'}"></span>
            <div>
                <em>{{ Number(prepaidCardRefundInfo.remainCash).toLocaleString() }}</em>
                <strong>{{ prepaidCardInfo.prepaidCardNickName }}</strong>
                <span>구매일<small>{{ prepaidCardInfo.issueDate }}</small></span>
            </div>
        </div>
        <div class="order-text-box">
            <div class="refund-info-box relative" >
                <strong>환불정보</strong>
                <button type="button" class="icon-black-question" v-on:click.stop="handlerQuestionButton"><span class="blind">환불정보버튼</span></button>
                <refund-info-modal v-if="isModal" :prepaidCardRefundInfo="prepaidCardRefundInfo"></refund-info-modal>
            </div>
            <div class="refund-schedule-box">
                <em>최종 충전 후 합계 잔액</em>
                <span>{{ Number(prepaidCardRefundInfo.refundBasedAmount).toLocaleString() }}원</span>
                <small class="refund-small">( {{prepaidCardRefundInfo.lastPaymentDate}} )</small>
            </div>
            <div class="refund-schedule-box">
                <em>환불 예정 금액</em>
                <span>{{ Number(prepaidCardRefundInfo.refundAmount).toLocaleString() }}원
                  <small class="refund-small">
                    (사용금액 {{ Number(prepaidCardRefundInfo.refundBasedAmount - prepaidCardRefundInfo.remainCash).toLocaleString() }}원, 사용률 {{prepaidCardRefundInfo.redeemRate}}%)
                  </small>
                </span>
            </div>
            <small class="refund-small refund-info-bottom">※ 환불예정 금액은 실 결제액과 결제 할인액의 각 사용율을 반영</small>
        </div>
        <div class="order-text-box">
            <div class="refund-info-box pt-0">
                <strong>환불안내</strong>
            </div>
        </div>
        <div class="save-precautions py-0" style="margin-bottom: 2rem">
            <ul>
              <li>
                  <p><span></span><em>최종 충전 후 합계 잔액 60% 이상 사용된 경우에만 가능합니다.</em></p>
              </li>
              <li>
                  <p><span></span><em>할인 판매된 이마티콘의 경우 구매 금액을 기준으로 사용 비율에 따라 남은 비율 잔액에 대해 환불됩니다.</em></p>
              </li>
<!--              <li>-->
<!--                <p><span></span><em>개인정보 관련 자세한 사항은 이마트 홈페이지(<a style="text-decoration: underline;" href="https://www.emart.com">www.emart.com</a>)-->
<!--                  <a style="color: red;text-decoration: underline;" href="https://eapp.emart.com/member/personal_info.do">개인정보처리방침</a>에서 확인 가능합니다.</em></p>-->
<!--              </li>-->
            </ul>
        </div>
        <div class="order-text-box">
          <div class="refund-info-box pt-0">
            <strong>개인정보 수집/이용 안내</strong>
          </div>
        </div>
        <div class="terms-gray-box" style="margin-top:0 !important; margin-bottom: 1.5rem;">
          <span>개인정보 수집/이용 안내</span>
          <button @click="showAgreePopupEvent('termsOfPrivateRefundInfo')">보기</button>
        </div>
        <!--
            환불 불가능시
            <bg-gray-text class="mb-32" text="이마티콘 60% 미만 사용으로 환불이 불가능합니다."></bg-gray-text>
        -->
        <bg-gray-text v-if="validRefundAmount && this.prepaidCardRefundInfo.paymentVoid !== true" class="mb-32" text="이마티콘 60% 이상 사용으로 잔액 환불 가능합니다."></bg-gray-text>
        <gray-line class="mx-reset"></gray-line>
        <div class="order-text-box pb-32" v-if="this.validRefundAmount == true">
          <div class="refund-info-box">
            <strong>환불 받을 계좌를 입력해주세요.</strong>
          </div>
                <!-- <span>은행선택</span> -->
                <!-- <button class="icon-bottom-arrow"></button> -->
                <select class="icon-bottom-arrow" v-model="refundBankCode">
                  <option v-for="item in bankList" :key="item.bankCode" :value="item.bankCode">
                    {{item.bankName}}
                  </option>
                </select>
            <input type="text" placeholder="예금주 이름" v-model="refundCustomerName" />
            <input type="number" placeholder="계좌번호 입력" v-model="refundAccountNo"/>
        </div>
        <gray-line class="mx-reset"></gray-line>
        <div class="save-precautions">
            <div>
              <span class="icon-tool-tip"></span>
              <strong>환불 유의사항</strong>
            </div>
            <ul>
              <li>
                <p><span></span><em>환불 신청 후 신청하신 계좌로 환불 처리되며, 영업일 기준 7일이내 환급해 드립니다.</em></p>
              </li>
              <li>
                  <p><span></span><em>미사용한 이마티콘은 구매 취소가 가능합니다.</em></p>
              </li>
              <li>
                  <p><span></span><em>이마티콘의 개별/충전 금액을 기준으로 60% 이상 사용한 경우에만 잔액 환급을 신청할 수 있습니다.</em></p>
              </li>
              <li>
                  <p><span></span><em>할인 구매/충전한 이마티콘의 경우에는 실제 구매한 금액을 기준으로 잔액을 계산하여 환급해 드립니다.</em></p>
                  <p><em>예) 이마티콘 10만 원권을 9만 원으로 10% 할인 구매 후, <br>6만 원을 사용한 뒤 환불 신청을 할 경우 잔액 4만 원에서 10%를 제외한 3.6만 원을 환불해 드립니다.</em></p>
              </li>
              <li>
                <p><span></span><em>마케팅/사은품용으로 지급된 이마티콘은 환급이 되지 않습니다.</em></p>
              </li>
            </ul>
        </div>
        <div class="fixed">
          <div class="button-wrap">
            <button @click="caseRefund()" :class="!validRefundAmount || prepaidCardInfo.goodsType === 'B2B'? 'button-disabled' : 'button-bg-yellow'" :disabled="!validRefundAmount || prepaidCardInfo.goodsType === 'B2B'" >
              {{ prepaidCardInfo.goodsType === 'B2B'? "환불 불가능 상품으로 잔액환불 불가" : (validRefundAmount? "환불하기" : "충전 금액의 60% 미만 사용으로 잔액환불 불가") }}
            </button>
          </div>
        </div>
        <refund-succeed-popup v-if="showRefundSucceedPopup === true" @refundSucceedPopup="showRefundSucceedPopup = false"></refund-succeed-popup>
        <alert-popup v-if="showAlertPopup === true" @confirmPopupClickConfirm="showAlertPopup = false" :message="alertMessage"></alert-popup>
        <confirm-popup v-if="showConfirmPopup === true" @confirmPopupClickNo="showConfirmPopup = false" @confirmPopupClickYes="requestDiscardPrepaidCard()" :message="alertMessage"></confirm-popup>
        <agree-popup v-if="showAgreePopup === true" @close="showAgreePopup = false" :terms="showTerms"></agree-popup>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import BgGrayText from '@/components/common/BgGrayText.vue';
import GrayLine from '@/components/common/GrayLine.vue';
import apiList from "@/api/apiList";
import RefundSucceedPopup from "@/views/myemarticon/refundSucceedPopup.vue";
import AlertPopup from './alertPopup.vue';
import ConfirmPopup from './confirmPopup.vue';
import cscript from '@/plugins/commonScripts'
import RefundInfoModal from '@/components/common/RefundInfoModal.vue';
import AgreePopup from "@/views/products/AgreePopup.vue";

export default {
    name: 'Refund',
    components: { RefundInfoModal, RefundSucceedPopup, BottomButton, BgGrayText, GrayLine, AlertPopup, ConfirmPopup, AgreePopup },
    data() {
        return {
          bankList: [], //은행 리스트
          showRefundSucceedPopup: false,
          refundAmount: '', // 환불 대상 금액
          refundExpect: '', // 환불 예상 금액
          refundBankCode: '', //환불받을 은행
          refundCustomerName: '',  //환불받을 예금주
          refundAccountNo: '',  //환불받을 계좌번호
          prepaidCardInfo: {},  //카드 정보
          alertMessage: '', // 백엔드 응답 메시지
          showAlertPopup: false,  //경고창 팝업 숨김여부
          showConfirmPopup: false,  //컨펌 팝업 숨김여부
          discardPrepaidCardFlag: false,  //잔액 0일때 폐기여부 선택
          checkFlag: false,
          prepaidCardRefundInfo: {
            refundBasedAmount: 0,
            refundRequestAmount: 0,
            remainCash: 0,  //잔액
            lastPaymentDate: '',  //최근 충전일자
            lastCashAmount: 0,  //마지막 충전 금액
            lastRemainCash: 0,  //최종 충전 잔액
            discountAmount: 0,  //
            redeemAmount: 0,  //사용금액
            redeemRate: 0,  //사용율
            remainRate: 0,  //남은 잔액율
            refundAmount: 0,  //환불잔액
            paymentVoid: '',  //사용여부: 미사용 환불 가능하게 해야하므로 true
          },  //선불카드 환불 신청전 선불카드 정보
          publicIP:'',  // 페이지 진입한 사용자의 공인 IP
          isModal: false, //? 버튼 눌렀을때 모달 열림/닫히는 이벤트
          cashNo: this.$route.params.cardInfo.cashNo, //환불처리 해야할 캐시넘버
          showAgreePopup: false,  //이용약관 팝업 보여주기 여부
          showTerms:'', //이용약관
        }
    },
    mounted() {
      this.$heading('환불');
      // 구매/충전내역, 카드상세에서 넘겨받은 파라미터를 Vuex Store에 저장
      if( (this.$route.params.cardInfo != null && this.$route.params.cardInfo !== undefined && this.$route.params.cardInfo !== '')
          || (this.$route.params.cardInfo.prepaidCardNo !== undefined && this.$route.params.cardInfo.prepaidCardNo != null))  {
        this.$store.commit('setPrepaidCardNo', this.$route.params.cardInfo.prepaidCardNo);
      }
      this.getBankInfo(); //은행정보
      this.getPublicIP(); //IP정보 가져오기
      this.getPrepaidCardInfo() //선불카드 정보 가져오기
      this.getPrepaidCardRefundInfo()  //선불카드 환불 신청전 선불카드 정보 가져오기
      window.scrollTo({ left: 0, top:0})
    },
    computed: {
      validRefundAmount() { //환불가능 조건을 계산한다
        if ( (this.prepaidCardRefundInfo.isPGAfterVoid === true)  //미사용으로 인한 구매취소로 100% 환불
              || (this.prepaidCardRefundInfo.redeemRate >= 60 && this.prepaidCardRefundInfo.isPGAfterVoid === false)  // 일반취소 조건
        ) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      async getPrepaidCardRefundInfo(){  //선불카드 환불 신청전 선불카드 정보 가져오기

        const params = {
          cashNo: this.cashNo,
        }

        const res = await apiList.getRefundInfo(params, {prepaidCardNo: this.$store.state.prepaidCardNo})
        this.prepaidCardRefundInfo = res.data.data
      },
      async getPrepaidCardInfo() {  //선불카드 정보 가져오기
        try {
          const res = await apiList.getPrePaidCardBox({size: '1', pageNo: '1', prepaidCardNo: this.$store.state.prepaidCardNo});
          // console.log("선불카드 가져온 정보:" +  JSON.stringify(res.data.data))
          this.prepaidCardInfo = res.data.data.list[0];
        } catch (err) {
          console.log(err)
        }
      },
      async getBankInfo() { //은행정보
        try {
          const res = await apiList.getBankInfo()
          this.bankList = res.data.data
          this.bankList.unshift({ "bankCode": "", "bankName": "은행을 선택하세요", "bankType":  "BANK", "representative": true })
        } catch (err) {
          console.log("error: ", err)
        }
      },
      async validAccount() {  //계좌 유효성 검증
        const params = {
          bankCode: this.refundBankCode,  //은행코드
          accountNo: this.refundAccountNo,  //계좌번호
          accountName: this.refundCustomerName, //예금주
          mberNo: this.$store.state.mberInfo.mberNo,  //회원번호
          comparativeSkip: '',  //이름 검증 플래그
          requestIp: this.publicIP  //공인 IP
        };

        console.log("validAccount :: " + JSON.stringify(params));

        const res = await apiList.getAccountVerification(params);
        console.log("validAccount result :: " + JSON.stringify(res));

        if (res.status ===  200 ) {
          // 계좌 유효성 검증 성공
          this.requestRefund()
        } else {
        // 계좌 유효성 검증 실패
          this.alertMessage = res.message
          this.showAlertPopup = true
          return false
        }

      },
      async requestRefund() {

        const params = {
          ctmmnyNo: this.$store.state.partnerId,
          prepaidCardNo: this.prepaidCardInfo.prepaidCardNo,
          mberNo: this.$store.state.mberInfo.mberNo,
          refundRequestAmount: this.prepaidCardRefundInfo.refundRequestAmount,
          requestId: this.$store.state.mberInfo.mberNo,
          methodName: 'POST',
          refundFee: 0,
          refundAmount: this.prepaidCardRefundInfo.refundAmount,
          bankCode : this.refundBankCode,
          bankAccountNo: this.refundAccountNo,
          bankAccountName : this.refundCustomerName ,
          cashNo: this.cashNo
        }

        console.log("requestRefund" + JSON.stringify(params))

        const res = await apiList.postRequestRefund(params)

        console.log("postRequestRefund:: " + JSON.stringify(res))
        //성공시 팝업 발생
        if (res.data) {
          this.showRefundSucceedPopup = true
        } else {
          //실패시 메시지 발생
          // console.log(JSON.stringify(res.data.data));
          this.alertMessage = res.message
          this.showAlertPopup = true
        }
      },
      async requestDiscardPrepaidCard() { //환불금액 0일때 팝업
          this.showConfirmPopup = false
          this.requestRefund()
      },
      async caseRefund() {
        //잔액 0일때 - 선불카드 폐기처리
        // if (this.prepaidCardInfo.remainCash == '0') {
        //   // this.showConfirmPopup = true
        // } else {
        //
        // }
        //잔액 0이 아닐때 - 환불 프로세스
        this.validForm()
        if (this.checkFlag) {
          this.validAccount()
        }
      },
      validForm() {
        //환불 양식 작성여부 확인
        if (cscript.$isEmpty(this.refundBankCode)) {
          this.checkFlag = false
          this.alertMessage = '은행을 선택해야 합니다'
          this.showAlertPopup = true
          return;
        }
        if (cscript.$isEmpty(this.refundCustomerName)) {
          this.checkFlag = false
          this.alertMessage = '예금주 이름을 입력해야 합니다'
          this.showAlertPopup = true
          return;
        }
        if (cscript.$isEmpty(this.refundAccountNo)) {
          this.checkFlag = false
          this.alertMessage = '계좌번호를 입력해야 합니다'
          this.showAlertPopup = true
          return;
        }
        this.checkFlag = true
      },
      getPublicIP(){  //IP정보 가져오기
        fetch("https://api.ipify.org/?format=json")
            .then(promiseResult => promiseResult.json())
            .then(result =>{
              this.publicIP = result.ip
            })
      },
      handlerQuestionButton() { //? 버튼 눌렀을때 모달 열림/닫히는 이벤트

        this.isModal = !this.isModal;
      },
      // 환불 상세 정보 모달을 닫는 함수
      modalClose(){

        if(this.isModal){
          this.isModal = false;
        }
      },
      /**
       * 이용약관 보여주기
       */
      showAgreePopupEvent(term){
        this.showTerms = term
        this.showAgreePopup = true
      },
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/refund.scss';
  @import '@/assets/styles/common/termsBox.scss';
</style>
